import { render, staticRenderFns } from "./Haikubox.vue?vue&type=template&id=0a47c616"
import script from "./Haikubox.vue?vue&type=script&lang=js"
export * from "./Haikubox.vue?vue&type=script&lang=js"
import style0 from "./Haikubox.vue?vue&type=style&index=0&id=0a47c616&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports